import React from "react";
import { useSearchParams } from "react-router-dom";
import OrderList from "./OrderList";
import CreditRequests from "./CreditRequests";

const OrdersLayout: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView = searchParams.get("tab") === "credit" ? "credit" : "orders";

  const handleTabChange = (view: "orders" | "credit") => {
    setSearchParams({ tab: view }, { replace: true });
  };
  return (
    <div className="min-h-screen bg-slate-50 font-inter antialiased">
      <main className="px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* --- Top Header & View Switcher --- */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-slate-200 pb-4">
          <h1 className="text-2xl font-bold text-slate-800">
            {activeView === "orders" ? "Order Management" : "Credit Dashboard"}
          </h1>

          <div className="flex bg-slate-200 p-1 rounded-lg self-end sm:self-auto">
            <button
              onClick={() => handleTabChange("orders")}
              className={`px-6 py-2 text-sm font-semibold rounded-md transition-all ${
                activeView === "orders"
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-slate-600 hover:text-slate-900"
              }`}
            >
              All Orders
            </button>
            <button
              onClick={() => handleTabChange("credit")}
              className={`px-6 py-2 text-sm font-semibold rounded-md transition-all ${
                activeView === "credit"
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-slate-600 hover:text-slate-900"
              }`}
            >
              Credit Requests
            </button>
          </div>
        </div>

        {/* --- Conditional Rendering of Components --- */}
        <div className="mt-6">
          {activeView === "orders" ? <OrderList /> : <CreditRequests />}
        </div>
      </main>
    </div>
  );
};

export default OrdersLayout;
